import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getWorkOrdersProducts: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].GET_WORK_ORDERS_PRODUCTS,
	},

	getWorkOrdersProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].GET_WORK_ORDERS_PRODUCT,
	},

	createWorkOrdersProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].CREATE_WORK_ORDERS_PRODUCT,
	},

	putWorkOrdersProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].PUT_WORK_ORDERS_PRODUCT,
	},

	patchWorkOrdersProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].PATCH_WORK_ORDERS_PRODUCT,
	},

	deleteWorkOrdersProduct: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.WORK_ORDERS_PRODUCTS].DELETE_WORK_ORDERS_PRODUCT,
	},
}
